import {
  Button,
  Form,
  Image,
  Input,
  Select,
  Modal,
  Upload,
  message
} from "antd";

import {
  DeleteOutlined,
  PlusOutlined,
  UploadOutlined
} from "@ant-design/icons";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import axiosInstance from "../../utils/axios";

export default function IndexPageForm({
  id,
  initialValues = {},
  onSubmit
}) {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [uploading, setUploading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      form.setFieldsValue({
        index_page_image: initialValues?.index_page_image || "",
        index_page_link: initialValues?.index_page_link || "",
        index_page_position:
          initialValues?.index_page_position || "hero"
      });

      setPreviewUrl(initialValues?.index_page_image || "");
    }
  }, [initialValues, form]);

  const uploadBanner = async (file) => {
    try {
      setUploading(true);

      const formData = new FormData();

      const ext =
        file?.name?.includes(".")
          ? file.name.split(".").pop()
          : "jpg";

      const safeName =
        `banner-home-${Date.now()}.${ext}`;

      formData.append(
        "product_link",
        file,
        safeName
      );

      const result = await axios.post(
        `${process.env.REACT_APP_API_URL}/upload/image`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      const uploadedPath = result?.data;

      if (!uploadedPath) {
        throw new Error("Server không trả về đường dẫn ảnh");
      }

      const finalUrl =
        String(uploadedPath).startsWith("http")
          ? String(uploadedPath)
          : `${process.env.REACT_APP_API_URL}${uploadedPath}`;

      form.setFieldValue(
        "index_page_image",
        finalUrl
      );

      setPreviewUrl(finalUrl);

      message.success(
        "Đã tải ảnh banner lên thành công"
      );
    } catch (error) {
      console.error(
        "UPLOAD_BANNER_ERROR",
        error
      );

      message.error(
        error?.response?.data?.message ||
        "Không tải được ảnh banner"
      );
    } finally {
      setUploading(false);
    }

    return false;
  };

  const deleteIndexPage = async () => {
    if (!id || id === "tao-moi") return;

    try {
      await axiosInstance.delete(
        `/index-page/deleteIndexPage/${id}`
      );

      message.success(
        "Đã xoá banner thành công!"
      );

      navigate(
        "/admin/quan-ly-trang-chu"
      );
    } catch (error) {
      message.error(
        "Không xoá được banner"
      );
    }
  };

  const confirmDelete = () => {
    Modal.confirm({
      title: "Xoá banner",
      content:
        "Bạn có chắc chắn xoá banner này?",
      okText: "Xoá",
      cancelText: "Huỷ",
      okButtonProps: {
        danger: true
      },
      onOk: deleteIndexPage
    });
  };

  const handleFinish = async (values) => {
    const imageUrl =
      values?.index_page_image?.trim();

    if (!imageUrl) {
      message.error(
        "Bạn chưa tải ảnh banner lên"
      );

      return;
    }

    if (uploading) {
      message.warning(
        "Ảnh vẫn đang được tải lên, vui lòng chờ"
      );

      return;
    }

    await onSubmit({
      index_page_image: imageUrl,
      index_page_link:
        values?.index_page_link?.trim() || "",
      index_page_position:
        values?.index_page_position || "hero"
    });
  };

  return (
    <div
      style={{
        maxWidth: 980,
        margin: "0 auto",
        padding: 24
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 24
        }}
      >
        <div>
          <h2
            style={{
              margin: 0,
              fontSize: 24,
              fontWeight: 700
            }}
          >
            {id && id !== "tao-moi"
              ? "Cập nhật banner trang chủ"
              : "Tạo banner trang chủ"}
          </h2>

          <div
            style={{
              marginTop: 5,
              color: "#64748b"
            }}
          >
            Ảnh sẽ được tải lên server trước
            khi lưu banner.
          </div>
        </div>

        {id && id !== "tao-moi" && (
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={confirmDelete}
          >
            Xoá
          </Button>
        )}
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          index_page_image:
            initialValues?.index_page_image || "",
          index_page_link:
            initialValues?.index_page_link || "",
          index_page_position:
            initialValues?.index_page_position || "hero"
        }}
      >
        <div
          style={{
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 16,
            padding: 22
          }}
        >
          <Form.Item
            label="Ảnh banner"
            required
          >
            <Upload
              accept="image/png,image/jpeg,image/webp"
              maxCount={1}
              showUploadList={false}
              beforeUpload={uploadBanner}
            >
              <Button
                icon={<UploadOutlined />}
                loading={uploading}
                size="large"
              >
                {uploading
                  ? "Đang tải ảnh..."
                  : "Chọn ảnh banner"}
              </Button>
            </Upload>

            <div
              style={{
                marginTop: 8,
                color: "#64748b",
                fontSize: 13
              }}
            >
              Nên dùng banner ngang.
              PNG, JPG hoặc WEBP.
            </div>
          </Form.Item>

          <Form.Item
            name="index_page_image"
            label="Đường dẫn ảnh"
            rules={[
              {
                required: true,
                message:
                  "Vui lòng chọn Banner!"
              }
            ]}
          >
            <Input
              placeholder="URL ảnh sẽ tự điền sau khi upload"
              readOnly
            />
          </Form.Item>

          {previewUrl && (
            <div
              style={{
                marginBottom: 22
              }}
            >
              <div
                style={{
                  marginBottom: 8,
                  fontWeight: 600
                }}
              >
                Xem trước
              </div>

              <div
                style={{
                  overflow: "hidden",
                  maxWidth: 760,
                  borderRadius: 12,
                  border:
                    "1px solid #e5e7eb",
                  background: "#f8fafc"
                }}
              >
                <Image
                  src={previewUrl}
                  alt="Banner preview"
                  style={{
                    width: "100%",
                    maxHeight: 320,
                    objectFit: "contain"
                  }}
                />
              </div>
            </div>
          )}

          <Form.Item
            name="index_page_position"
            label="Vị trí banner"
            rules={[
              {
                required: true,
                message:
                  "Vui lòng chọn vị trí banner"
              }
            ]}
          >
            <Select
              size="large"
              options={[
                {
                  value: "hero",
                  label:
                    "Banner chính đầu trang"
                },
                {
                  value: "promo",
                  label:
                    "Banner ưu đãi - Mục 5"
                }
              ]}
            />
          </Form.Item>

          <Form.Item
            name="index_page_link"
            label="Link khi bấm banner"
          >
            <Input
              size="large"
              placeholder="Ví dụ: https://cuahangykhoa.com/..."
            />
          </Form.Item>

          <div
            style={{
              display: "flex",
              gap: 10,
              marginTop: 26
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={uploading}
              disabled={uploading}
            >
              {id && id !== "tao-moi"
                ? "Lưu thay đổi"
                : "Tạo banner"}
            </Button>

            <Button
              size="large"
              onClick={() =>
                navigate(
                  "/admin/quan-ly-trang-chu"
                )
              }
            >
              Huỷ
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
}
